import classNames from "classnames";
import React from "react";

import { LoadingSpinner } from "../../../common/LoadingSpinner";
import { ConfiguratorTypes } from "../../../constants";

interface IProps {
    configuratorType: ConfiguratorTypes;
    alternatePriceView?: boolean;
}

export const ConfiguratorPriceLoading = (props: IProps): React.JSX.Element => {
    const priceClasses = classNames({
        "configurator__price": true,
        "configurator__price--loading": true,
        [`configurator__price--${props.configuratorType}`]: true,
        "configurator__price--alternate": props.alternatePriceView,
    });
    return (
        <div className={priceClasses}>
            <LoadingSpinner fadeIn="quarter" />
        </div>
    );
};
